import axios, { AxiosRequestHeaders } from 'axios'

export interface FetchBannerSearchParams {
  type: 'search' | 'category' | 'collection' | 'url'
  value: string
  headers?: AxiosRequestHeaders
}

interface BannerImage {
  url: string
  width: number
  height: number
}

export interface BannerSearchResponse {
  label: string
  entryId: string
  promotionId: string
  promotionName: string
  creativeName: string
  creativeSlot: string
  imageDesktop?: BannerImage
  imageMobile?: BannerImage
  urlRedirect: string
  matchMode: string
}

export const fetchBannerSearch = async ({
  type,
  value,
  headers
}: FetchBannerSearchParams): Promise<BannerSearchResponse | null> => {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_BFF_ECOMMERCE}/catalog/banners/search`,
      {
        params: {
          type,
          value
        },
        headers
      }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching banner search:', error)
    return null
  }
}
